<template>
  <basic-location
    ref="zipChooserRef"
    v-model="formData.location"
    :contract-start-date="$props.contractStartDate"
    :v="v.location"
    :label="getTranslation('form.zipCode.title')"
    @update:modelValue="handleLocationUpdate"
  />
</template>

<script setup>
  import { computed, reactive, watch } from 'vue'
  import { required } from '@vuelidate/validators'
  import useVuelidate from '@vuelidate/core'

  import useMedicalOffice from '@shared/hooks/useMedicalOffice'
  import { BasicLocation } from '@shared/components/Basic'

  // HOOKS
  const { getTranslation } = useMedicalOffice()

  // INIT
  const emit = defineEmits(['blur', 'focus', 'search'])
  const props = defineProps({
    contractStartDate: {
      type: String,
      required: true
    },

    location: {
      type: Object,
      default: () => {},
    },
  })

  // DATA
  const formData = reactive({
    location: { ...props.location },
  })

  // COMPUTED
  const isValid = computed(() => {
    return Boolean(formData.location?.zipCode)
  })

  // METHODS
  function handleLocationUpdate() {
    if (isValid.value) {
      emit('search', formData.location)
    }
  }

  const rules = {
    location: { required },
  }

  const v = useVuelidate(rules, formData)

  // WATCHERS
  watch(
    () => props.location,
    location => {
      if (!location) {
        return
      }
      formData.location = location
    }
  )

  watch(formData.location, () => {
    handleLocationUpdate()
  })
</script>

<style scoped>
.location-search {
  height: auto;

  &__title {
    padding: var(--fixed-spacing-fix-04) 0;
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-bold-lg);
    letter-spacing: var(--letter-spacing-bold-lg);
    line-height: var(--line-height-bold-lg);
  }
}
</style>
